import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import AtlassianSwitcher, {
	fetchProductRecommendations,
	createJoinableSitesProvider,
} from '@atlassian/switcher';

import { fg } from '@confluence/feature-gating';

import { useSessionData } from '@confluence/session-data';

const maxHeightWrapper = xcss({
	maxHeight: 'calc(100vh - 100px)',
});

const joinableProductsInSwitcherProvider = createJoinableSitesProvider(
	fetchProductRecommendations('/gateway/api/invitations'),
);

export const AppSwitcherContent = () => {
	const { cloudId } = useSessionData();

	return (
		<Box xcss={maxHeightWrapper}>
			<AtlassianSwitcher
				product="confluence"
				cloudId={cloudId}
				joinableSitesDataProvider={
					fg('joinable_products_in_switcher_gate') ? joinableProductsInSwitcherProvider : undefined
				}
			/>
		</Box>
	);
};
